import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { makeAutoObservable, runInAction } from "mobx";
import {
  IRepositoryUserTreePageDto,
  PresentationDetailDto,
} from "../models/dto";
import { IDiskUser, IPresentationEditPageDto, PresentationDetailsFormValues } from "../models/repositoryUser";
import { toast } from "react-toastify";

export default class PresentationStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  currentRepositoryTree: IRepositoryUserTreePageDto | null = null;
  presentationDetails: PresentationDetailDto | null = null;
  presentationDetailsIsLoaded: boolean = false;
  currentRepositoryPageIndex: number = 0;
  totalPageNumber: number = 0;
 presentationEditPage :IPresentationEditPageDto |null =null
 errorsFilesUploaded: string[]=[];
 addPresentationMessage = "";

 showErrorFilesUploadedModal: boolean = false;

 diskSpaceUser: IDiskUser | null = null;
 folderSizeFull: boolean = false;
 
 closeShowErrorFileUploadedModal = () => {
  this.showErrorFilesUploadedModal = false;
}
 openShowErrorFileUploadedModal = () => {
  this.showErrorFilesUploadedModal = true;
}

  loadRepository = async () => {
    try {
      const{canViewSurveys, attendingMeeting}= this.rootStore.playerStore;
      const{setSurveyParameters}= this.rootStore.surveyStore
      const {canViewODG}= this.rootStore.tenantStore
      const dto = await agent.RepositoryUser.repository();
      runInAction(() => {
        this.currentRepositoryTree = dto;
      
      });
    
      if (!canViewODG &&canViewSurveys && attendingMeeting) setSurveyParameters(attendingMeeting.id);
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

   loadDiskSpaceUser = async () => {
    try {
      const dto = await agent.RepositoryUser.getUserSpaceDisk();
      runInAction(() => {
        this.diskSpaceUser = dto;
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
   }
    resetDiskSpaceUser = () => {
    this.diskSpaceUser = null;
   }


  resetMainRepository = () => {
    this.currentRepositoryTree = null;
  };

  loadPresentationDetails = async (presentationId: number) => {
    try {
      const dto = await agent.RepositoryUser.presentationDetailsPlayer(
        presentationId
      );
      runInAction(() => {
        this.rootStore.commonStore.setRepositoryBrowsePageContent(dto);
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };


//  addPresentation = async ( parentNodeId: number | undefined, nodeDetails: PresentationDetailsFormValues, isVisibleOnPodium: boolean |undefined, isGlobalGuestRequest = false) => {
//     try {
//       console.log(parentNodeId)
//       let parentNodeIdNumber= 0;
//       if(parentNodeId !== undefined) parentNodeIdNumber = parseInt(parentNodeId?.toString());
//     const dto=  await agent.RepositoryUser.addPresentation(parentNodeIdNumber , nodeDetails, isVisibleOnPodium,isGlobalGuestRequest);

//     if(isGlobalGuestRequest && dto.insertedContentsIds && dto.insertedContentsIds.length > 0){
//       let percentage = await agent.Content.checkPresentationIsReady(dto.insertedContentsIds);
//     }
//     runInAction(()=>{
//       this.errorsFilesUploaded= dto.errorfiles;
//       this.rootStore.playerStore.closeShowPresentationModal();
//       if(dto.errorfiles && dto.errorfiles.length > 0){
//         this.errorsFilesUploaded= dto.errorfiles;
//       this.openShowErrorFileUploadedModal()
//       }
//       this.loadRepository()
//     })
//      return dto;
//     } catch (error) {
//       console.log(error);
//       throw error;
//     }
//   };
addPresentation = async (parentNodeId: number | undefined, nodeDetails: PresentationDetailsFormValues, isVisibleOnPodium: boolean | undefined, isGlobalGuestRequest = false) => {
  try {
    this.addPresentationMessage = "uploading";
    console.log(parentNodeId);
    let parentNodeIdNumber = 0;
    if (parentNodeId !== undefined) parentNodeIdNumber = parseInt(parentNodeId?.toString());
    const dto = await agent.RepositoryUser.addPresentation(parentNodeIdNumber, nodeDetails, isVisibleOnPodium, isGlobalGuestRequest);

    if (isGlobalGuestRequest && dto.insertedContentsIds && dto.insertedContentsIds.length > 0) {
      console.log("GOLABLGUEST");
      const checkPresentationReady = () => {
        this.addPresentationMessage = "converting";
        return new Promise<number>((resolve, reject) => {
          const interval = setInterval(async () => {
            try {
              let percentage = await agent.Content.checkPresentationIsReady(dto.insertedContentsIds!);
              if (percentage >= 100) {
                clearInterval(interval);
                runInAction(() => {
                  this.errorsFilesUploaded = dto.errorfiles;
                  this.rootStore.playerStore.closeShowPresentationModal();
                  if (dto.errorfiles && dto.errorfiles.length > 0) {
                    this.errorsFilesUploaded = dto.errorfiles;
                    this.openShowErrorFileUploadedModal();
                  }
                  this.loadRepository();
                });
                resolve(percentage);
              }
            } catch (error) {
              clearInterval(interval);
              reject(error);
            }
          }, 1000); // Call the function again after 1 second
        });
      };

      dto.completedPercentage = await checkPresentationReady(); // Start the periodic check
    } 
    else {
      console.log("QUI");
   console.log("dto :" + JSON.stringify(dto));
      runInAction(() => {
        this.folderSizeFull = dto.folderSizeFull? dto.folderSizeFull : false;
        this.errorsFilesUploaded = dto.errorfiles;
        this.rootStore.playerStore.closeShowPresentationModal();
        if (dto.errorfiles && dto.errorfiles.length > 0) {
          this.errorsFilesUploaded = dto.errorfiles;
          this.openShowErrorFileUploadedModal();
        }
        this.loadRepository();
        this.loadDiskSpaceUser();
      });
    }

    return dto;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

  addPresentationNode = async ( presentationId: number | undefined, nodeDetails: PresentationDetailsFormValues) => {
    try {
      await agent.RepositoryUser.addPresentationNode( presentationId, nodeDetails);
      toast.success("Aggiunta contenuto con successo");
    } catch (error) {
      console.log(error);
      toast.error("errore aggiunta contenuto");
      throw error;
    }
  };

  updatePresentation = async ( presentationId: number | undefined, nodeDetails: PresentationDetailsFormValues) => {
    try {
      await agent.RepositoryUser.updatePresentation( presentationId, nodeDetails);
      toast.success("Aggiornato il titolo");
    } catch (error) {
      console.log(error);
      toast.error("errore aggiornamento");
      throw error;
    }
  };

   presentationDetail = async (PresentationId: number) => {
    try {
      const dto = await agent.RepositoryUser.details(PresentationId);
      
				runInAction(() => {
          this.presentationEditPage=dto;
        });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };


  deletePresentation = async (PresentationId: number) => {
    try {
      await agent.RepositoryUser.deletePresentation(PresentationId);
    
    } catch (error) {
      console.log(error);
   
      throw error;
    }
  };
}
